<template>
  <div class="app" >
    <!-- <navigationnew v-if="copyright"></navigationnew> -->
       <navigationGF v-if="copyright.entrantsType == 8" />
    <navigation v-else-if="copyright"></navigation>
  

    <router-view v-if="ifNew" class="router-box" :key="$route.fullPath" />
    <footer class="footer">
      <footersGF v-if="copyright.entrantsType == 8" />

      <footers v-else-if="copyright"></footers>
    </footer>
  </div>
</template>
<script> 
// import navigation from "@/components/navigation";
import navigationnew from "@/components/navigationnew";
import footers from "@/components/footers";
import navigation from "@/components/navigation";
import footersGF from "../components/footersGF.vue"; 
import navigationGF from "@/components/navigationGF";

import { getDomain, setDomain, setDomainToken } from "@/api/cookies";
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: {
    navigation,
    navigationnew,
    footers,
    footersGF,
    navigationGF
  },
  data() {
    return {
      copyright: {},
      ifNew: false,
    };
  },
  async created() {
      this.copyright = getDomain() || {};
      this.$store.state.hidePurchaseButtons = Number(this.copyright.entrantsType) === 8;
      // 优先显示当前机构名，兼容旧版机构缓存的 name 字段。
      document.title = this.copyright.lesseeName || this.copyright.name || '';
      // this.copyright.entrantsType = 8
      console.log(this.copyright,'copyright');
      
      // 检查缓存是否过期（24小时）
      const lastDnsCall = localStorage.getItem('lastDnsCall');
      const now = new Date().getTime();
      const cacheExpiry = 24 * 60 * 60 * 1000; // 24小时
      
      if (!lastDnsCall || (now - parseInt(lastDnsCall)) > cacheExpiry) {
        // 缓存过期，调用 API 更新数据
        await homeClient.getDnsOneApi().then((res) => {
          if (res.code == 0) {
            setDomainToken(res.data.domainToken) 
            setDomain(res.data.entrants)
            localStorage.setItem('isXiaoQingWang', res.data.xiaoQingId)
            this.copyright = res.data.entrants;
            // 接口刷新机构配置后，在页面挂载前同步购买按钮的显隐状态。
            this.$store.state.hidePurchaseButtons = Number(this.copyright.entrantsType) === 8;
            // 域名配置刷新后同步标题，首次访问无需等待下一次路由切换。
            document.title = this.copyright.lesseeName || this.copyright.name || '';
            // 更新缓存时间
            localStorage.setItem('lastDnsCall', now.toString());
          }
          this.ifNew = true;
        });
      } else {
        // 缓存未过期，使用现有数据
        this.ifNew = true;
      }
  },
  watch: {
    $route() {
      window.scrollTo(0, 0);
    }
  },
};
</script>
<style lang="less" scoped>
.app {
  width: 100%;
  // height: 100%;
  min-height: 100vh;
  position: relative;
}
</style>
